import React from "react";
import { NavDropdown } from "react-bootstrap";
import { useAuth } from "./../../contexts/authContext";
import nl_flag from "../../assets/img/flags/NL.png";
import de_flag from "../../assets/img/flags/DE.png";
import gb_flag from "../../assets/img/flags/GB.png";
import es_flag from "../../assets/img/flags/ES.png";
import us_flag from "../../assets/img/flags/US.png";

const LanguageMenu: React.FC = ({ }) => {
    const { user, changeLanguage } = useAuth()

    let locale = 'nl-NL'
    if (user && user.language)
        locale = user.language;

    let userFlag = nl_flag
    switch (locale) {
        case 'en-GB':
            userFlag = gb_flag
            break;
        case 'en-US':
            userFlag = us_flag
            break;
        case 'de-DE':
            userFlag = de_flag
            break;
        case 'es-ES':
            userFlag = es_flag
            break;
    }

    return (
        <NavDropdown id="basic-nav-dropdown-3" className="dropdown-with-icons" title={
            <div style={{ float: "left", marginTop: -5, marginBottom: 10 }}>
                <img height={20} src={userFlag} />
            </div>
        }>
            {locale !== 'de-DE' && (
                <NavDropdown.Item onClick={() => changeLanguage('de-DE')}>
                    <div>
                        <div style={{ float: "left", marginLeft: 10 }}>
                            <img height={20} src={de_flag} />
                        </div>
                        <p>Deutsch</p>
                    </div>
                </NavDropdown.Item>
            )}
            {locale !== 'en-GB' && (
                <NavDropdown.Item onClick={() => changeLanguage('en-GB')}>
                    <div>
                        <div style={{ float: "left", marginLeft: 10 }}>
                            <img height={20} src={gb_flag} />
                        </div>
                        <p>English GB</p>
                    </div>
                </NavDropdown.Item>
            )}
            {locale !== 'en-US' && (
                <NavDropdown.Item onClick={() => changeLanguage('en-US')}>
                    <div>
                        <div style={{ float: "left", marginLeft: 10 }}>
                            <img height={20} src={us_flag} />
                        </div>
                        <p>English US</p>
                    </div>
                </NavDropdown.Item>
            )}
            {locale !== 'es-ES' && (
                <NavDropdown.Item onClick={() => changeLanguage('es-ES')}>
                    <div>
                        <div style={{ float: "left", marginLeft: 10 }}>
                            <img height={20} src={es_flag} />
                        </div>
                        <p>Español</p>
                    </div>
                </NavDropdown.Item>
            )}
            {locale !== 'nl-NL' && (
                <NavDropdown.Item onClick={() => changeLanguage('nl-NL')}>
                    <div>
                        <div style={{ float: "left", marginLeft: 10 }}>
                            <img height={20} src={nl_flag} />
                        </div>
                        <p>Nederlands</p>
                    </div>
                </NavDropdown.Item>
            )}
        </NavDropdown>
    )
}
export default LanguageMenu;